import { render, staticRenderFns } from "./category.vue?vue&type=template&id=4936a15e&scoped=true&"
import script from "./category.vue?vue&type=script&lang=js&"
export * from "./category.vue?vue&type=script&lang=js&"
import style0 from "./category.vue?vue&type=style&index=0&id=4936a15e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4936a15e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\00_GIT\\hotel\\hotel-front-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4936a15e')) {
      api.createRecord('4936a15e', component.options)
    } else {
      api.reload('4936a15e', component.options)
    }
    module.hot.accept("./category.vue?vue&type=template&id=4936a15e&scoped=true&", function () {
      api.rerender('4936a15e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/point_shop/category.vue"
export default component.exports